module.exports = "/dog-racing/img/third-dog.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/img/third-dog.png
// module id = 1958
// module chunks = 7